import SectionContent from "./SectionContent";
import { getBranchInfobyId } from "../util/multipleBranch/getActiveBranchId";
import classes from "./DisplaySummary.module.css"
import {useState} from "react";
export default function DisplaySummary({branchId, summary}) {
//   let summaryData = JSON.parse(localStorage.getItem("summaryData"));
 
   const [expandedIndex, setExpandedIndex] = useState(0);
     const maxChars = 150; // Adjust this value as needed


  let branchInfo = getBranchInfobyId(branchId);
 
  if (summary.length == 0) return <p>No summary data available. Data Generated Every Week on Monday</p>;
  return (
    <div className={classes.summaryContainer}>
         
        {summary.map((item, index) => {
           
            return (
                
                   <div key={index} className={classes.summaryItem}>
                     <h3 className={classes.branchName}>{branchInfo ? branchInfo.name : "Branch " + branchId}</h3>
                    <h4>Dates : {new Date(new Date(item.createdAt).getTime() - 7 * 24 * 60 * 60 * 1000).toLocaleDateString()} - {new Date(new Date(item.createdAt).getTime() - 24 * 60 * 60 * 1000).toLocaleDateString()}</h4>
                    <div key={index} className={classes.textContainer}>
                        <pre className={classes.summaryText}>
                            {expandedIndex === index ? item.summary : item.summary.substring(0, maxChars) + (item.summary.length > maxChars ? '...' : '')}
                        </pre>
                        {item.summary.length > maxChars && (
                            <button onClick={() => setExpandedIndex(expandedIndex === index ? null : index)}>
                                {expandedIndex === index ? 'Less' : 'Read More'}
                            </button>
                        )}
                    </div>
                   </div>
                
            );
        })}
        </div>
  );
}